//internal-deps
import { AnalyticsContextValue } from "@swiggy-private/analytics";

//constants
import { IMPRESSION_ACTIONS, SCREEN_NAME } from "@payment-client/analytics/constants";

export const onImpressionBTCToggle = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    selected: boolean,
    context: string,
    screenName?: string,
): void => {
    impressionEvent({
        category: screenName || SCREEN_NAME.PAYMENT,
        action: IMPRESSION_ACTIONS.IMPRESSION_BTC_TOGGLE,
        label: selected ? 1 : 0,
        context,
    });
};
